import Grid from "@mui/material/Grid";
import { useAuth } from "../../core/context/auth.context";
import useScreenSize from "../../core/hooks/use-screen-size";
import useUserOs from "../../core/hooks/use-user-os";
import UserDebtsListComponent from "../user-debts-list.component";
import UserService from "../../core/service/user.service";
import { useQuery } from "@tanstack/react-query";
import Typography from "@mui/material/Typography";
import formatCurrency from "../../core/helpers/format-currency.helper";
import { Skeleton } from "@mui/material";

export default function OwedToMeTab() {
  const { user } = useAuth();
  const screenSize = useScreenSize();
  const { isIOS } = useUserOs();

  const innerContainerSize = screenSize.height - (isIOS ? 180 : 165); // magic numbers

  const userService = new UserService();

  const { data: userStats, refetch } = useQuery({
    queryKey: [`singleUserData`, { userId: user!.id }],
    queryFn: () => userService.getStats(user!.id),
    initialData: undefined,
  });

  const onDebtChange = async () => {
    await refetch();
  };

  return (
    <Grid item xs={12} height="80vh">
      <Typography
        textAlign="center"
        style={{
          textShadow: "none",
          fontWeight: 300,
          padding: 10,
          marginBottom: 10,
          color: "#fff",
        }}
      >
        {!userStats?.data && (
          <Skeleton variant="text" sx={{ fontSize: "1.6rem" }} />
        )}
        {userStats?.data && (
          <>
            Total owed to me:{" "}
            <Typography color="success.main" fontWeight="500" display="inline">
              {formatCurrency(userStats?.data?.owed, "USD")}
            </Typography>
          </>
        )}
      </Typography>
      <UserDebtsListComponent
        height={innerContainerSize - 120}
        type="to-user"
        onDebtChange={onDebtChange}
        pageSize={Math.floor((innerContainerSize - 100) / 80)}
        noItemsText="No player owes you"
      />
    </Grid>
  );
}
